import NavigationBehaviourSettingsPanel from "components/control/settings/NavigationBehaviourSettingsPanel";

/** Dev popup tab: behaviour profile + Navigate To Pose fallback editor. */
const DevNavBehaviorPanel: React.FC = () => (
    <NavigationBehaviourSettingsPanel variant="devPopup" />
);

export default DevNavBehaviorPanel;
